'use strict';

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */

module.exports = function isNaN(value) {
	return value !== value;
};



//////////////////
// WEBPACK FOOTER
// ./~/is-nan/implementation.js
// module id = 402
// module chunks = 0